import { Alert, Badge, Table } from "flowbite-react";
import TitleStripe from "../TitleStripe";
import NoOcurrence from "./NoOcurrence";
import {
  formatToReal,
  getImageURLScore,
  getScoreDescricao,
} from "../../../utils/utils";
import moment from "moment";
import AvisoCard from "./AvisoCard";
import ParticipacaoEmEmpresas from "./ParticipacaoEmEmpresas";
import { EvaluationScore } from "./EvaluationScore";
import ChequesSustados from "./ChequesSustados";
import ChequesSemFundos from "./ChequesSemFundos";
import Protestos from "./Protestos";
import ReactApexChart from "react-apexcharts";
import AcoesCiveis from "./AcoesCiveis";
import PendenciasFinanceiras from "./PendenciasFinanceiras";
import HistoricoConsultas from "./HistoricoConsultas";

const AvaliaMaxPJ = ({ data }) => {
  return (
    <>
      {data?.statusRetorno == 1 ? (
        <>
          <div className="mt-6 border rounded-2xl shadow p-6 bg-white">
            <h3 className="text-lg font-bold mb-4 border-b pb-2">
              📋 Dados Cadastrais
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-700">
              <div>
                <strong>Razão Social:</strong>{" "}
                {data?.reports?.[0]?.registration?.companyName ||
                  "Indisponível"}
              </div>
              <div>
                <strong>CNPJ:</strong>{" "}
                {data?.reports?.[0]?.registration?.companyDocument ||
                  "Indisponível"}
              </div>
              <div>
                <strong>Situação:</strong>{" "}
                {data?.reports?.[0]?.registration?.statusRegistration ||
                  "Indisponível"}
              </div>
              <div>
                <strong>Data de Fundação:</strong>{" "}
                {data?.reports?.[0]?.registration?.foundationDate
                  ? moment(
                      data?.reports?.[0]?.registration?.foundationDate
                    ).format("DD/MM/YYYY")
                  : "Indisponível"}
              </div>
              <div>
                <strong>Cidade:</strong>{" "}
                {data?.reports?.[0]?.registration?.address?.city ||
                  "Indisponível"}
              </div>
              <div>
                <strong>Estado:</strong>{" "}
                {data?.reports?.[0]?.registration?.address?.state ||
                  "Indisponível"}
              </div>
            </div>
          </div>

          <div>
            <TitleStripe className="mb-5">Participação Societária</TitleStripe>

            {data?.reports?.[0]?.partner?.PartnerResponse?.results?.length >
            0 ? (
              <div className="overflow-x-hidden border-gray-100 border rounded-lg mt-3">
                <Table striped>
                  <Table.Head className="text-black">
                    <Table.HeadCell
                      className="text-center py-2 px-1"
                      style={{ background: "#3EED98" }}
                    >
                      Nº
                    </Table.HeadCell>
                    <Table.HeadCell
                      className="py-2"
                      style={{ background: "#3EED98" }}
                    >
                      Nome
                    </Table.HeadCell>
                    <Table.HeadCell
                      className="text-center py-2 px-1"
                      style={{ background: "#3EED98" }}
                    >
                      Part. (%)
                    </Table.HeadCell>
                    <Table.HeadCell
                      className="text-center py-2 px-1"
                      style={{ background: "#3EED98" }}
                    >
                      Débitos
                      <br />
                      (S/N)
                    </Table.HeadCell>
                  </Table.Head>
                  {data?.reports?.[0]?.partner?.PartnerResponse?.results
                    ?.length > 0 && (
                    <Table.Body className="divide-y">
                      {data?.reports?.[0]?.partner?.PartnerResponse?.results?.map(
                        (socio, index) => (
                          <Table.Row
                            key={index}
                            className="bg-white dark:border-gray-700 dark:bg-gray-800 text-black"
                          >
                            <Table.Cell className="font-medium dark:text-white text-center py-1 px-1">
                              {index + 1}
                            </Table.Cell>
                            <Table.Cell className=" py-1">
                              <div>{socio?.name || "-"}</div>
                              <div style={{ fontSize: "10px" }}>
                                CPF/CNPJ: {socio?.documentId}
                              </div>
                            </Table.Cell>
                            <Table.Cell className="text-center py-1 px-1 px-1">
                              {socio?.participationPercentage || "-"}
                            </Table.Cell>
                            <Table.Cell className="text-center py-1 px-1">
                              {socio?.hasNegative ? "SIM" : "NÃO"}
                            </Table.Cell>
                          </Table.Row>
                        )
                      )}
                    </Table.Body>
                  )}
                </Table>
              </div>
            ) : (
              <NoOcurrence />
            )}
          </div>

          <div>
            <TitleStripe className="mb-5">
              Administradores/Diretores
            </TitleStripe>
            {data?.reports?.[0]?.director?.DirectorResponse?.results?.length >
            0 ? (
              <div className="overflow-x-hidden border-gray-100 border rounded-lg mt-3">
                <Table striped>
                  <Table.Head className="text-black">
                    <Table.HeadCell
                      className="text-center py-2 px-1"
                      style={{ background: "#3EED98" }}
                    >
                      Nº
                    </Table.HeadCell>
                    <Table.HeadCell
                      className="py-2"
                      style={{ background: "#3EED98" }}
                    >
                      Nome
                    </Table.HeadCell>
                    <Table.HeadCell
                      className="text-center py-2 px-1"
                      style={{ background: "#3EED98" }}
                    >
                      Cargo
                    </Table.HeadCell>
                    <Table.HeadCell
                      className="text-center py-2 px-1"
                      style={{ background: "#3EED98" }}
                    >
                      Débitos (S/N)
                    </Table.HeadCell>
                  </Table.Head>
                  <Table.Body className="divide-y">
                    {data?.reports?.[0]?.director?.DirectorResponse?.results?.map(
                      (diretor, index) => (
                        <Table.Row
                          key={index}
                          className="bg-white dark:border-gray-700 dark:bg-gray-800 text-black"
                        >
                          <Table.Cell className="font-medium dark:text-white text-center py-1 px-1">
                            {index + 1}
                          </Table.Cell>
                          <Table.Cell className="py-1">
                            <div>{diretor?.name || "-"}</div>
                            <div style={{ fontSize: "10px" }}>
                              {diretor?.documentType}: {diretor?.documentId}
                            </div>
                          </Table.Cell>
                          <Table.Cell className="text-center py-1 px-1">
                            {diretor?.role || "-"}
                          </Table.Cell>
                          <Table.Cell className="text-center py-1 px-1">
                            {diretor?.hasNegative ? "SIM" : "NÃO"}
                          </Table.Cell>
                        </Table.Row>
                      )
                    )}
                  </Table.Body>
                </Table>
              </div>
            ) : (
              <NoOcurrence />
            )}
          </div>

          <TitleStripe>Quadro de avisos</TitleStripe>
          <div className="container-alerts four-columns">
            <AvisoCard
              title="Pend. Comerciais"
              hasRestrictions={
                +data?.reports?.[0]?.negativeData?.pefin?.summary?.count > 0
              }
              messageError={`${+data?.reports?.[0]?.negativeData?.pefin?.summary
                ?.count} ocorrências`}
            />

            <AvisoCard
              title="Pend. Financeiras"
              hasRestrictions={
                +data?.reports?.[0]?.negativeData?.refin?.summary?.count > 0
              }
              messageError={`${+data?.reports?.[0]?.negativeData?.refin?.summary
                ?.count} ocorrências`}
            />

            <AvisoCard
              title="Protestos"
              hasRestrictions={
                +data?.reports?.[0]?.negativeData?.notary?.summary?.count > 0
              }
              messageError={`${+data?.reports?.[0]?.negativeData?.notary
                ?.summary?.count} ocorrências`}
            />

            <AvisoCard
              title="Cheques Sem Fundo"
              hasRestrictions={
                +data?.reports?.[0]?.negativeData?.check?.summary?.count > 0
              }
              messageError={`${+data?.reports?.[0]?.negativeData?.check?.summary
                ?.count} ocorrências`}
            />
          </div>

          <div>
            <TitleStripe>Score de risco</TitleStripe>
          </div>
          <div className="flex flex-col gap-2 items-center">
            {!data?.reports?.[0]?.score?.message?.includes("NAO CALCULADO") ? (
              <div className="flex justify-center items-center gap-4 mb-3 mt-2">
                <div className="p-4">
                  <img
                    src={getImageURLScore(+data?.reports?.[0]?.score?.score)}
                    style={{ minWidth: "340px" }}
                  />
                  <div className="text-center font-semibold text-3xl">
                    {data?.reports?.[0]?.score?.score}
                  </div>
                </div>
                <div className="text-center text-sm text-gray-600 mb-4 -mt-4 bg-gray-50 p-2 border border-gray-300">
                  {getScoreDescricao(data?.reports?.[0]?.score?.score)}
                </div>
              </div>
            ) : (
              <Alert className="mt-2" color="gray">
                {data?.reports?.[0]?.score?.message}
              </Alert>
            )}
          </div>

          <div>
            <TitleStripe className="mb-5">Histórico de consultas</TitleStripe>
            {data?.reports?.[0]?.facts?.inquiryCompanyResponse?.results
              ?.length > 0 ? (
              <>
                <div className="overflow-x-hidden border-gray-100 border rounded-lg mt-3">
                  <Table striped>
                    <Table.Head>
                      <Table.HeadCell
                        className="text-center text-black"
                        style={{ background: "#3EED98" }}
                      >
                        Data
                      </Table.HeadCell>
                      <Table.HeadCell
                        className="text-center text-black"
                        style={{ background: "#3EED98" }}
                      >
                        Empresa
                      </Table.HeadCell>
                    </Table.Head>
                    {data?.reports?.[0]?.facts?.inquiryCompanyResponse?.results
                      ?.length > 0 && (
                      <Table.Body className="divide-y">
                        {data?.reports?.[0]?.facts?.inquiryCompanyResponse?.results?.map(
                          (pendencia, index) => (
                            <Table.Row
                              key={index}
                              className="bg-white dark:border-gray-700 dark:bg-gray-800"
                            >
                              <Table.Cell className="font-medium text-black dark:text-white text-center py-1">
                                {moment(pendencia?.occurrenceDate).format(
                                  "DD/MM/yyyy"
                                ) || "-"}
                              </Table.Cell>
                              <Table.Cell className="text-center py-1 text-black">
                                {(pendencia?.companyName
                                  ?.toUpperCase()
                                  .includes("ENJOY") ||
                                pendencia?.companyName
                                  ?.toUpperCase()
                                  .includes("42.283.377") ||
                                pendencia?.companyName
                                  ?.toUpperCase()
                                  .includes("MEJER")
                                  ? "GRANDES BANCOS"
                                  : pendencia?.companyName) || "-"}
                              </Table.Cell>
                            </Table.Row>
                          )
                        )}
                      </Table.Body>
                    )}
                  </Table>
                </div>
                <span className="mt-2 block text-xs italic">
                  Exibindo as últimas 5 ocorrências
                </span>
              </>
            ) : (
              <NoOcurrence />
            )}
          </div>

          {/* <EvaluationScore
            data={data}
            score={data?.consultaCredito?.score?.score}
            probability={data?.consultaCredito?.score?.probabilidade}
          /> */}

          <div className="-mt-6">
            <TitleStripe className="mb-5">Pendências Comerciais</TitleStripe>
            {data?.reports?.[0]?.negativeData?.pefin?.pefinResponse?.length >
            0 ? (
              <>
                <div className="flex gap-6">
                  <div className="flex gap-2 items-center">
                    <span className="font-semibold text-red-700">
                      Quantidade:{" "}
                    </span>
                    <Badge color="failure" className="w-fit">
                      {data?.reports?.[0]?.negativeData?.pefin?.summary?.count}
                    </Badge>
                  </div>

                  <div className="flex gap-2 items-center">
                    <span className="font-semibold text-red-700">
                      Valor Total:{" "}
                    </span>
                    <Badge color="failure" className="w-fit">
                      {formatToReal(
                        data?.reports?.[0]?.negativeData?.pefin?.summary
                          ?.balance
                      )}
                    </Badge>
                  </div>
                </div>
                <div className="overflow-x-hidden border-gray-100 border rounded-lg mt-3">
                  <Table striped>
                    <Table.Head>
                      <Table.HeadCell
                        className="text-center text-black"
                        style={{ background: "#3EED98" }}
                      >
                        Data
                      </Table.HeadCell>
                      <Table.HeadCell
                        className="text-center text-black"
                        style={{ background: "#3EED98" }}
                      >
                        Informante
                      </Table.HeadCell>
                      <Table.HeadCell
                        className="text-center text-black"
                        style={{ background: "#3EED98" }}
                      >
                        Valor
                      </Table.HeadCell>
                      <Table.HeadCell
                        className="text-center text-black"
                        style={{ background: "#3EED98" }}
                      >
                        Contrato
                      </Table.HeadCell>
                    </Table.Head>
                    {data?.reports?.[0]?.negativeData?.pefin?.pefinResponse
                      ?.length > 0 && (
                      <Table.Body className="divide-y">
                        {data?.reports?.[0]?.negativeData?.pefin?.pefinResponse?.map(
                          (pendencia, index) => (
                            <Table.Row
                              key={index}
                              className="bg-white dark:border-gray-700 dark:bg-gray-800"
                            >
                              <Table.Cell className="font-medium text-black dark:text-white text-center py-1">
                                {moment(pendencia?.occurrenceDate).format(
                                  "DD/MM/yyyy"
                                ) || "-"}
                              </Table.Cell>
                              <Table.Cell className="text-center py-1 text-black">
                                {pendencia?.creditorName || "-"}
                              </Table.Cell>
                              <Table.Cell className="text-center py-1 text-black">
                                {formatToReal(pendencia?.amount)}
                              </Table.Cell>
                              <Table.Cell className="text-center py-1 text-black">
                                {pendencia?.contractId || "-"}
                              </Table.Cell>
                            </Table.Row>
                          )
                        )}
                      </Table.Body>
                    )}
                  </Table>
                </div>
                <span className="mt-2 block text-xs italic">
                  Exibindo as últimas 5 ocorrências
                </span>
              </>
            ) : (
              <NoOcurrence />
            )}

            <div>
              <TitleStripe className="mb-5">Pendências Financeiras</TitleStripe>
              {data?.reports?.[0]?.negativeData?.refin?.refinResponse?.length >
              0 ? (
                <>
                  <div className="flex gap-6">
                    <div className="flex gap-2 items-center">
                      <span className="font-semibold text-red-700">
                        Quantidade:{" "}
                      </span>
                      <Badge color="failure" className="w-fit">
                        {
                          data?.reports?.[0]?.negativeData?.refin?.summary
                            ?.count
                        }
                      </Badge>
                    </div>

                    <div className="flex gap-2 items-center">
                      <span className="font-semibold text-red-700">
                        Valor Total:{" "}
                      </span>
                      <Badge color="failure" className="w-fit">
                        {formatToReal(
                          data?.reports?.[0]?.negativeData?.refin?.summary
                            ?.balance
                        )}
                      </Badge>
                    </div>
                  </div>
                  <div className="overflow-x-hidden border-gray-100 border rounded-lg mt-3">
                    <Table striped>
                      <Table.Head>
                        <Table.HeadCell
                          className="text-center text-black"
                          style={{ background: "#3EED98" }}
                        >
                          Data
                        </Table.HeadCell>
                        <Table.HeadCell
                          className="text-center text-black"
                          style={{ background: "#3EED98" }}
                        >
                          Informante
                        </Table.HeadCell>
                        <Table.HeadCell
                          className="text-center text-black"
                          style={{ background: "#3EED98" }}
                        >
                          Valor
                        </Table.HeadCell>
                        <Table.HeadCell
                          className="text-center text-black"
                          style={{ background: "#3EED98" }}
                        >
                          Contrato
                        </Table.HeadCell>
                      </Table.Head>
                      {data?.reports?.[0]?.negativeData?.refin?.refinResponse
                        ?.length > 0 && (
                        <Table.Body className="divide-y">
                          {data?.reports?.[0]?.negativeData?.refin?.refinResponse?.map(
                            (pendencia, index) => (
                              <Table.Row
                                key={index}
                                className="bg-white dark:border-gray-700 dark:bg-gray-800"
                              >
                                <Table.Cell className="font-medium text-black dark:text-white text-center py-1">
                                  {moment(pendencia?.occurrenceDate).format(
                                    "DD/MM/yyyy"
                                  ) || "-"}
                                </Table.Cell>
                                <Table.Cell className="text-center py-1 text-black">
                                  {pendencia?.creditorName || "-"}
                                </Table.Cell>
                                <Table.Cell className="text-center py-1 text-black">
                                  {formatToReal(pendencia?.amount)}
                                </Table.Cell>
                                <Table.Cell className="text-center py-1 text-black">
                                  {pendencia?.contractId || "-"}
                                </Table.Cell>
                              </Table.Row>
                            )
                          )}
                        </Table.Body>
                      )}
                    </Table>
                  </div>
                  <span className="mt-2 block text-xs italic">
                    Exibindo as últimas 5 ocorrências
                  </span>
                </>
              ) : (
                <NoOcurrence />
              )}
            </div>
            <div>
              <TitleStripe className="mb-5">Protestos</TitleStripe>
              {data?.reports?.[0]?.negativeData?.notary?.notaryResponse
                ?.length > 0 ? (
                <>
                  <div className="flex gap-6">
                    <div className="flex gap-2 items-center">
                      <span className="font-semibold text-red-700">
                        Quantidade:{" "}
                      </span>
                      <Badge color="failure" className="w-fit">
                        {
                          data?.reports?.[0]?.negativeData?.notary?.summary
                            ?.count
                        }
                      </Badge>
                    </div>

                    <div className="flex gap-2 items-center">
                      <span className="font-semibold text-red-700">
                        Valor Total:{" "}
                      </span>
                      <Badge color="failure" className="w-fit">
                        {formatToReal(
                          data?.reports?.[0]?.negativeData?.notary?.summary
                            ?.balance
                        )}
                      </Badge>
                    </div>
                  </div>
                  <div className="overflow-x-hidden border-gray-100 border rounded-lg mt-3">
                    <Table striped>
                      <Table.Head>
                        <Table.HeadCell
                          className="text-center text-black"
                          style={{ background: "#3EED98" }}
                        >
                          Data
                        </Table.HeadCell>
                        <Table.HeadCell
                          className="text-center text-black"
                          style={{ background: "#3EED98" }}
                        >
                          Cartório
                        </Table.HeadCell>
                        <Table.HeadCell
                          className="text-center text-black"
                          style={{ background: "#3EED98" }}
                        >
                          Valor
                        </Table.HeadCell>
                      </Table.Head>
                      {data?.reports?.[0]?.negativeData?.notary?.notaryResponse
                        ?.length > 0 && (
                        <Table.Body className="divide-y">
                          {data?.reports?.[0]?.negativeData?.notary?.notaryResponse?.map(
                            (pendencia, index) => (
                              <Table.Row
                                key={index}
                                className="bg-white dark:border-gray-700 dark:bg-gray-800"
                              >
                                <Table.Cell className="font-medium text-black dark:text-white text-center py-1">
                                  {moment(pendencia?.occurrenceDate).format(
                                    "DD/MM/yyyy"
                                  ) || "-"}
                                </Table.Cell>
                                <Table.Cell className="text-center py-1 text-black">
                                  {pendencia?.officeNumber || "-"}
                                </Table.Cell>
                                <Table.Cell className="text-center py-1 text-black">
                                  {formatToReal(pendencia?.amount)}
                                </Table.Cell>
                              </Table.Row>
                            )
                          )}
                        </Table.Body>
                      )}
                    </Table>
                  </div>
                  <span className="mt-2 block text-xs italic">
                    Exibindo as últimas 5 ocorrências
                  </span>
                </>
              ) : (
                <NoOcurrence />
              )}
            </div>

            <div>
              <TitleStripe className="mb-5">Cheques sem fundos</TitleStripe>
              {data?.reports?.[0]?.negativeData?.check?.checkResponse?.length >
              0 ? (
                <>
                  <div className="flex gap-6">
                    <div className="flex gap-2 items-center">
                      <span className="font-semibold text-red-700">
                        Quantidade:{" "}
                      </span>
                      <Badge color="failure" className="w-fit">
                        {
                          data?.reports?.[0]?.negativeData?.check?.summary
                            ?.count
                        }
                      </Badge>
                    </div>

                    <div className="flex gap-2 items-center">
                      <span className="font-semibold text-red-700">
                        Valor Total:{" "}
                      </span>
                      <Badge color="failure" className="w-fit">
                        {formatToReal(
                          data?.reports?.[0]?.negativeData?.check?.summary
                            ?.balance
                        )}
                      </Badge>
                    </div>
                  </div>
                  <div className="overflow-x-hidden border-gray-100 border rounded-lg mt-3">
                    <Table striped>
                      <Table.Head>
                        <Table.HeadCell
                          className="text-center text-black"
                          style={{ background: "#3EED98" }}
                        >
                          Data
                        </Table.HeadCell>
                        <Table.HeadCell
                          className="text-center text-black"
                          style={{ background: "#3EED98" }}
                        >
                          Banco
                        </Table.HeadCell>
                        <Table.HeadCell
                          className="text-center text-black"
                          style={{ background: "#3EED98" }}
                        >
                          Nº Cheque
                        </Table.HeadCell>
                        <Table.HeadCell
                          className="text-center text-black"
                          style={{ background: "#3EED98" }}
                        >
                          Qtd.
                        </Table.HeadCell>
                      </Table.Head>
                      {data?.reports?.[0]?.negativeData?.check?.checkResponse
                        ?.length > 0 && (
                        <Table.Body className="divide-y">
                          {data?.reports?.[0]?.negativeData?.check?.checkResponse?.map(
                            (pendencia, index) => (
                              <Table.Row
                                key={index}
                                className="bg-white dark:border-gray-700 dark:bg-gray-800"
                              >
                                <Table.Cell className="font-medium text-black dark:text-white text-center py-1">
                                  {moment(pendencia?.occurrenceDate).format(
                                    "DD/MM/yyyy"
                                  ) || "-"}
                                </Table.Cell>
                                <Table.Cell className="text-center py-1 text-black">
                                  {pendencia?.bankName || "-"}
                                </Table.Cell>
                                <Table.Cell className="text-center py-1 text-black">
                                  {pendencia?.checkNumber || "-"}
                                </Table.Cell>
                                <Table.Cell className="text-center py-1 text-black">
                                  {pendencia?.checkCount || "-"}
                                </Table.Cell>
                              </Table.Row>
                            )
                          )}
                        </Table.Body>
                      )}
                    </Table>
                  </div>
                  <span className="mt-2 block text-xs italic">
                    Exibindo as últimas 5 ocorrências
                  </span>
                </>
              ) : (
                <NoOcurrence />
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <TitleStripe>Avalia Max PJ</TitleStripe>
          <Alert className="mt-2" color="gray" withBorderAccent>
            Consulta indisponível no momento!
          </Alert>
        </>
      )}
    </>
  );
};

export default AvaliaMaxPJ;
